let pyodide: any = null;
let isLoading: boolean = false;
let listeners: ((pyodide: any) => void)[] = [];

export async function getPyodideInstance(): Promise<any> {
  if (pyodide) {
    return pyodide;
  }

  if (isLoading) {
    return new Promise((resolve) => {
      listeners.push(resolve);
    });
  }

  isLoading = true;

  const loadedPyodide = await (window as any).loadPyodide?.({
    indexURL: 'https://cdn.jsdelivr.net/pyodide/v0.24.1/full/',
  });

  await loadedPyodide.loadPackage(['numpy', 'scipy', 'matplotlib']);
  await loadedPyodide.runPythonAsync(`
    import sys

    class Console:
        def __init__(self):
            self.buffer = []
        def write(self, text):
            if text.strip():
                self.buffer.append(text)
        def flush(self): pass

    sys.stdout = sys.stderr = Console()
  `);

  pyodide = loadedPyodide;
  listeners.forEach((fn) => fn(pyodide));
  listeners = [];

  return pyodide;
}
